import { FC } from "react";
import Text, { TextProps } from "..";

import styles from "./styles.module.scss";

type Props = TextProps & {
    type: "currency" | "percentage";
    decimals?: number;
};

const Stat: FC<Props> = ({ children, type, decimals = 0, className, variant, ...rest }) => {
    const getColor = () => {
        const result = Number(children);
        if (isNaN(result)) return "";
        if (result > 0) return styles.positive;
        if (result < 0) return styles.negative;
        return "";
    };

    const getSuffix = () => {
        if (type === "currency") return "$";
        if (type === "percentage") return "%";
        return "";
    };

    const formatValue = () => {
        const value = Number(children);
        if (isNaN(value)) return children;
        
        return new Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        }).format(value);
    };

    return (
        <Text
            variant={variant}
            className={`${getColor()} ${className}`}
            {...rest}
        >
            {formatValue()}
            {getSuffix()}
        </Text>
    );
};

export default Stat;
